import type { FaireProductEntity } from "../../entity_types/product";

export const p_zw36j5vmab: FaireProductEntity = {
  token: "p_zw36j5vmab",
  type: "product",
  name: "Raffia Storage Box with Circus Theme - Large - Foldable",
  brandToken: "b_c8yganb0qb",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/cfb47078f0359795837b4e6cc4943fac8c0a52124830225b442a0efa7dceeb9e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0a48720d6f7910378e21284ff6c36343cd78d18f6d1c1b22468673a6ea107124.png",
  ],
  priceDollars: 100,
  description:
    "Extra large foldable raffia storage box with a playful circus theme. Perfect for organizing toys, blankets or everyday essentials while adding a decorative touch to your home. Lightweight, flexible and easy to store when not in use.\n",
  tags: [],
  msrpDollars: 199.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:34.481Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
